<template>
	<SelectMenu class="sml-select" :value="areaUrlCode" :items="legalAreasList" @input="onInput"/>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SelectMenu from "../SelectMenu.vue";

export default {
  components: {
    SelectMenu
  },
  computed: {
    ...mapState(["legalAreasList"]),
    ...mapGetters(["areaUrlCode", "searchQuery"])
  },
  methods: {
    onInput(areaUrlCode) {
      const searchQuery = this.searchQuery || undefined;
      if (areaUrlCode) {
        this.$router.replace({
          name: 'publicationsWithArea',
          params: {areaUrlCode, page: undefined},
          query: {searchQuery}
        });
        
        ga('send', 'event', 'publications', 'sort_dropdown', areaUrlCode);
      }
      else {
        this.$router.replace({
          name: 'publications',
          params: {page: undefined},
          query: {searchQuery}
        });
      }
    }
  }
};
</script>
